import { shade, tint } from "polished";

// valida hex (#rgb/#rrggbb) ou rgb()/rgba(); retorna a cor ou null
export const safeColor = (v) => {
  if (typeof v !== "string") return null;
  const cor = v.trim();
  const isHex = /^#([0-9a-f]{3}){1,2}$/i.test(cor);
  const isRgb = /^rgba?\(\s*\d{1,3}\s*,\s*\d{1,3}\s*,\s*\d{1,3}\s*(,\s*(\d*\.?\d+%?)\s*)?\)$/i.test(cor);
  return isHex || isRgb ? cor : null;
};

export function applyColor(theme, primary, background = null) {
  const themeWithPrimary = applyPrimaryColor(theme, primary);
  if (background) {
    const cor = safeColor(background);
    if (cor) {
      const themeWithBackground = applyBackgroundColor(themeWithPrimary, cor);
      return themeWithBackground;
    }
  }
  return themeWithPrimary;
}

export function applyPrimaryColor(theme, primary) {
  const cor = safeColor(primary);
  if (!cor) return theme;

  return {
    ...theme,
    colors: {
      ...theme.colors,
      primary: cor,
      primary500: cor,
      primaryDark: shade(0.4, cor),
      primary50: tint(0.8, cor),
      primary40: tint(0.9, cor),
      primary30: tint(0.93, cor),
    },
  };
}

export function applyBackgroundColor(theme, background) {
  const cor = safeColor(background);
  if (!cor) return theme;

  return {
    ...theme,
    colors: {
      ...theme.colors,
      background: cor,
    },
  };
}
